// extracted by mini-css-extract-plugin
export var layoutContainer = "_96-0";
export var layoutContainerNoRounding = "_96-6";
export var layoutContainerOpen = "_96-5";
export var layoutContainerResizing = "_96-1";
export var mainContent = "_96-2";
export var resizeDivider = "_96-3";
export var slidePanel = "_96-4";